import React from 'react';

const NavItem = ({ 
  icon: Icon, 
  label, 
  isActive, 
  onClick 
}) => {
  return (
    <button
      onClick={onClick}
      className={`
        w-full rounded-xl flex items-center p-1 transition-colors
        ${isActive 
          ? 'bg-[#F1F1F1] dark:bg-[#2A2A2A] border border-[#ECECEC] dark:border-[#202020]' 
          : 'bg-transparent hover:bg-[#F9F9F9] dark:hover:bg-[#1F1F1F]'
        }
      `}
    >
      <div className="flex items-center gap-3 flex-1">
        <div 
          className={`
            w-8 h-8 rounded-[10px] flex items-center justify-center shadow-sm
            ${isActive 
              ? 'bg-[#FCFCFC] dark:bg-[#1F1F1F]' 
              : 'bg-transparent'
            }
          `}
        >
          <Icon 
            size={20} 
            className={isActive 
              ? 'text-[#121212] dark:text-[#D0D0D0]' 
              : 'text-[#7B7B7B] dark:text-[#848484]'
            } 
          />
        </div>
        <span 
          className={`
            text-xs font-semibold leading-4 tracking-[-0.1px]
            ${isActive 
              ? 'text-[#121212] dark:text-[#D0D0D0]' 
              : 'text-[#121212] dark:text-[#D0D0D0]'
            }
          `}
        >
          {label}
        </span>
      </div>
    </button>
  );
};

export default NavItem;

